<template>
  <Loader v-if="loader" />
  <div class="card">
    <div class="flex flex-wrap col-12 p-0 m-3">
      <div class="col-6 sm:col-6 xl:col-4 flex justify-center items-center mx-auto" v-for="voce in voci" :key="voce.id">
        <Button :label="voce.descrizione.toUpperCase()" :class="`w-full btn-filter ${voce.selected ? 'selected' : ''}`"
          @click="onChangeVoce(voce)" />
      </div>
    </div>

    <div v-if="Object.keys(selected_voce).length">
      <div class="flex justify-content-between">
        <div class="flex justify-content-center mb-3">
          <Button icon="pi pi-angle-double-left" class="p-button-text p-button-rounded" @click="changeDate(false)" />
          <Calendar v-model="date" view="month" dateFormat="mm/yy" @update:modelValue="getData()"
            :manualInput="false" />
          <Button icon="pi pi-angle-double-right" class="p-button-text p-button-rounded" @click="changeDate()" />
        </div>
        <Button label="Vedi fatture emesse" icon="pi pi-folder-open"
          v-tooltip.left="`Vedi fatture emesse con voce ${selected_voce.descrizione.toLowerCase()}`"
          @click="openDialogfattureForVoce" v-if="hasVoceForFatture" />
      </div>

      <TabView v-model:activeIndex="active">
        <TabPanel v-for="tab in filtered_tabs" :key="tab.title" :header="tab.title">
          <DataTable v-model:filters="filters" :value="items[tab.type]" tableStyle="w-full" paginator :rows="20"
            :rowsPerPageOptions="[20, 50, 100]" sortField="has_voce" :globalFilterFields="['code']" filterDisplay="row">
            <template #empty>
              Non ci sono forniture per la voce "{{ selected_voce.descrizione.toLowerCase() }}" in ingresso dal mese
              selezionato
            </template>
            <template #header>
              <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                <div class="col-12 flex flex-wrap align-items-center justify-content-between gap-2">
                  <span class="text-xl text-900 ">Voce "{{ selected_voce.descrizione.toLowerCase() }}" di {{ tab.title
                    }} in
                    ingresso a {{ moment(date).format('MMMM YYYY') }}</span>
                  <Button :label="`Associa ${selected_voce.descrizione.toLowerCase()}`"
                    @click="elaboraVoce($event, tab.type)"
                    v-if="view_checkbox_select ? selectedItems.length : items[tab.type].length > 0" />
                </div>
                <div class="flex align-items-center" v-if="view_checkbox_select && canSelecteAll">
                  <Checkbox v-model="has_selectedItems" :binary="true" @update:modelValue="selectAllRows" class="m-3" />
                  <label>{{ has_selectedItems ? 'Deseleziona tutti' : 'Seleziona tutti' }}</label>
                </div>
              </div>
            </template>
            <Column headerStyle="width: 3rem" v-if="view_checkbox_select">
              <template #body="{ data }">
                <Checkbox v-if="data.canSelect" v-model="data.selected" :binary="true"
                  @update:modelValue="inSelectedItems(data)" />
              </template>
            </Column>
            <Column v-for="col of items.columns" :key="col.field" :field="col.field" :header="col.header"
              :type="col.type" :sortable="col.field == 'has_voce'" :showFilterMenu="false">
              <template #body="{ data }">
                <div v-if="col.type == 'link'">
                  <Button class="p-button-link" :label="data[col.field]" @click="goTo($event, data, col.field)" />
                </div>
                <div v-else-if="col.type == 'price'">
                  € {{ data[col.field].toFixed(2) }}
                </div>
                <div v-else-if="col.type == 'data'">
                  {{ data[col.field] != null ? moment(data[col.field]).format('DD/MM/Y') : data[col.field] }}
                </div>
                <div v-else>
                  {{ data[col.field] }}
                </div>
              </template>
              <template #filter="{ filterModel, filterCallback }" v-if="['code'].includes(col.field)">
                <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" />
              </template>
            </Column>
          </DataTable>
        </TabPanel>
      </TabView>

      <Dialog v-model:visible="visibleFattureForVoce" maximizable modal :style="{ width: '75%' }">
        <FattureForVoce :data="selected_voce.ft" :header="header_FatturaVoce" />
      </Dialog>
    </div>
  </div>
</template>

<script>
import Service from '@/services/ask-management/contratti-vendita-service'
import UtilityService from '@/services/ask-management/utility-service'
import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import Loader from '@/components/Loader.vue'
import moment from 'moment'
import { useToast } from 'primevue/usetoast';
import FattureForVoce from "./FattureForVoce.vue";
import { FilterMatchMode } from 'primevue/api';

export default {
  components: {
    Loader,
    FattureForVoce
  },
  setup() {
    const toast = useToast();
    const loader = ref(false)
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const utilityService = new UtilityService(self.$http, self.$eventBus)
    const selected_voce = ref({})
    const voci = ref([])
    const date = ref();
    const has_selectedItems = ref(true)
    const canSelecteAll = ref(false)
    const visibleFattureForVoce = ref(false)

    const items = ref({
      pods: [],
      pdrs: [],
      columns: []
    })
    const tabs = ref([
      { title: 'Pod', content: items.value.pods, type: 'pods' },
      { title: 'Pdr', content: items.value.pdrs, type: 'pdrs' },
    ]);
    const filtered_tabs = ref([])
    const voci_possibili = {
      36: { nome: 'depositi-cauzionali', tabs: ['pods', 'pdrs'] },
      162: { nome: 'subentri', tabs: ['pods'] },
      200: { nome: 'subentri', tabs: ['pdrs'] }
    }
    const selectedItems = ref([])
    const metaKey = ref(true);
    const view_checkbox_select = computed(() => {
      return filtered_tabs.value[active.value].type == 'pdrs' && selected_voce.value.id == 200
    })
    const active = ref(0)
    const header_FatturaVoce = ref('')
    const month = [
      "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
    ]
    const filters = ref({
      code: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    onMounted(() => {
      date.value = new Date()
      Promise.all([
        getVociFattura()
      ])
    })

    const isAssistenzaClientiOnly = () => {
      try {
        const profile = JSON.parse(atob(localStorage.getItem('user'))).user[0].profile
        return Number(profile?.assistenza_clienti) === 1 && Number(profile?.all) !== 1
      } catch (e) {
        return false
      }
    }

    const getVociFattura = async () => {
      const tutte = [
        { id: 36, code: "DEP_CAUZ", descrizione: "Deposito Cauzionale", cod_section: 3, cod_type_prezzo: 3, articolo_esenzione: "300", codiceConto: "5205040", codiceContoGAS: "5205020", selected: false, ft: [] },
        { id: 162, code: "SUB", descrizione: "SUBENTRO", cod_section: 3, cod_type_prezzo: 3, articolo_esenzione: null, codiceConto: "5805205", codiceContoGAS: "", selected: false },
        { id: 200, code: "SUB_GAS", descrizione: "SUBENTRO GAS", cod_section: 3, cod_type_prezzo: 3, articolo_esenzione: null, codiceConto: null, codiceContoGAS: "5805953", selected: false }
      ]
      voci.value = isAssistenzaClientiOnly() ? tutte.filter((voce) => voce.id === 36) : tutte
      if (voci.value.length === 1) {
        onChangeVoce(voci.value[0])
      }
    }

    const getData = async () => {
      initItems()
      loader.value = true
      let data_ingresso = moment(date.value).format('Y-MM')
      let fd = new FormData()
      fd.append('data', JSON.stringify(data_ingresso))
      fd.append('id_voce', selected_voce.value.id)
      canSelecteAll.value = false
      selectedItems.value = []

      await service.getFornitureVoceFattura(fd).then((res) => {
        Object.keys(res.items).forEach(type_supply => {
          res.items[type_supply].forEach(pp => {
            if (selected_voce.value.id == 200 && type_supply == 'pdrs') {
              pp.canSelect = !pp.has_voce
              if (pp.canSelect) {
                pp.selected = true
                selectedItems.value.push(pp)
                canSelecteAll.value = true
              }
            }
            pp.has_voce = pp.has_voce ? 'Si' : 'No'
          })
          items.value[type_supply] = res.items[type_supply]
        })
        setSelectedItems()
      }).finally(() => {
        loader.value = false
      })
    }
    const changeDate = (value = true) => {
      if (value) {
        date.value = new Date(moment(date.value).add(1, 'month'))
      } else {
        date.value = new Date(moment(date.value).subtract(1, 'month'))
      }
      getData()
    }

    const goTo = (evt, data, type_path) => {
      let path
      let type_data
      switch (type_path) {
        case 'cliente_name':
          path = `clienti`
          type_data = `cliente_id`
          break;
        case 'numero':
          path = `clienti/fatture`
          type_data = type_path
          break;
        case 'code':
          path = data.type_pp
          type_data = 'supply_id'
          break;
        case 'contratto_code':
          path = 'contratti/vendita'
          type_data = 'contratto_id'
          break;

        default:
          path = `${data.type_fornitura}s`
          type_data = `id_${data.type_fornitura}`
          break;
      }
      window.open(`/ask/${path}/${data[type_data]}/dettagli`, '_blank')
    }
    const initItems = () => {
      items.value = {
        pods: [],
        pdrs: [],
        columns: []
      }
    }

    const elaboraVoce = (evt, type) => {
      let items_in_elabora = view_checkbox_select.value ? selectedItems.value : items.value[type].filter(item => item.has_voce == 'No')

      let method = voci_possibili[selected_voce.value.id].nome
      if (items_in_elabora.length) {

        loader.value = true

        let fd = new FormData()
        fd.append('items', JSON.stringify(items_in_elabora))
        let data = moment(date.value).startOf('month').format('Y-MM-DD')
        fd.append('data', JSON.stringify(data))
        fd.append('id_voce', selected_voce.value.id)

        utilityService.setAllVoceFattura(fd, method)
          .then((res) => {
            res.items.forEach(item => {
              let severity = item.success ? 'success' : 'warn'
              let detail = `${item.code} - ${item.msg}`
              toast.add({ severity: severity, summary: '', detail: detail, life: 10000 })
            })
          }).finally(() => {
            Promise.all([getData()])
          })
      } else {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: `Non ci sono ${method} da registrare per il mese selezionato`, life: 5000 });
      }
    }
    const onChangeVoce = async (voce) => {
      voci.value.forEach(btn => {
        btn.selected = btn.id == voce.id
      })
      selected_voce.value = voce
      filtered_tabs.value = []
      tabs.value.forEach(tab => {
        if (voci_possibili[voce.id].tabs.includes(tab.type)) {
          filtered_tabs.value.push(tab)
        }
      })
      Promise.all([getData()])
    }
    const inSelectedItems = (data) => {
      if (data.selected) {
        selectedItems.value.push(data)
      } else {
        let index = selectedItems.value.findIndex(row => row.code == data.code)
        if (index != -1) {
          selectedItems.value.splice(index, 1)
        }
      }
      setSelectedItems()

    }
    const setSelectedItems = () => {
      has_selectedItems.value = selectedItems.value.length ? true : false
    }
    const selectAllRows = () => {
      selectedItems.value = []

      if (!has_selectedItems.value) {
        items.value[filtered_tabs.value[active.value].type].forEach(el => {
          el.selected = false
        })
      } else {
        items.value[filtered_tabs.value[active.value].type].forEach(el => {
          if (!el.selected && el.canSelect) {
            el.selected = true
            selectedItems.value.push(el)
          }
        })
      }
    }
    const openDialogfattureForVoce = () => {
      loader.value = true
      let fd = new FormData()
      let range = getRangeData()
      fd.append('range', JSON.stringify(range))
      let method = voci_possibili[selected_voce.value.id].nome

      utilityService.getFattureVoce(fd, method)
        .then((res) => {
          selected_voce.value.ft = res.items
        }).finally(() => {
          loader.value = false
          if (selected_voce.value.ft.length > 0) {
            let index_month = moment(date.value).month()
            let year = moment(date.value).year()
            header_FatturaVoce.value = `Fatture con ${selected_voce.value.descrizione} di ${month[index_month]} ${year}`
            visibleFattureForVoce.value = true
          } else {
            toast.add({ severity: 'secondary', detail: 'Non sono presenti fatture emesse con deposito cauzionale per il mese selezionato', life: 5000 })
          }
        })
    }

    const getRangeData = () => {
      return [
        moment(date.value).startOf('month').format('YYYY-MM-DD'),
        moment(date.value).endOf('month').format('YYYY-MM-DD')
      ]
    }

    const hasVoceForFatture = computed(() => {
      return 'ft' in selected_voce.value
    })

    return {
      date,
      moment,
      items,
      tabs,
      loader,
      service,
      changeDate,
      goTo,
      getData,
      elaboraVoce,
      voci,
      onChangeVoce,
      selectedItems,
      metaKey,
      view_checkbox_select,
      active,
      inSelectedItems,
      selectAllRows,
      has_selectedItems,
      canSelecteAll,
      filtered_tabs,
      visibleFattureForVoce,
      openDialogfattureForVoce,
      selected_voce,
      hasVoceForFatture,
      header_FatturaVoce,
      filters
    }
  }
}
</script>
<style>
.btn-filter {
  border-radius: 20px;
  width: 140px;
  height: 75px;
  opacity: 0.5;
  transition: opacity 0.2s ease-in-out;
}

.btn-filter:hover {
  opacity: 1;
}

.btn-filter.selected {
  /* opacity: 1; */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
</style>